/*
 * "Fulano está digitando…" do flarum-realtime com as reticências que ondulam
 * (`.presence-users .wave .dot`, 1,8s): os três
 * pontos sobem um depois do outro, no lugar do ícone "…" pulsando.
 *
 * Na lista de tópicos, o ponto pulsante do realtime (`fas fa-ellipsis-h
 * fa-beat`, na cor primária) vira uma pílula discreta no estilo das
 * etiquetas: a caneta e as mesmas reticências (`typingPill`, usada pela linha
 * da lista em list/listItem.tsx).
 */
import { extend } from 'flarum/common/extend';
import Icon from 'flarum/common/components/Icon';
function wave() {
  return m("span", {
    className: "CanelaWave",
    "aria-hidden": "true"
  }, m("span", {
    className: "CanelaWave-dot"
  }, "."), m("span", {
    className: "CanelaWave-dot"
  }, "."), m("span", {
    className: "CanelaWave-dot"
  }, "."));
}

/** A pílula "alguém está digitando" da lista de tópicos. */
export function typingPill(label) {
  return m("span", {
    className: "CanelaTyping",
    role: "status",
    "aria-label": label,
    title: label
  }, m(Icon, {
    name: "fas fa-pen",
    className: "CanelaTyping-icon"
  }), wave());
}
export default function installTyping() {
  // Só existe com o flarum-realtime; sem ele o onLoad nunca dispara.
  extend('ext:flarum/realtime/forum/components/TypingIndicator', 'view', function (vdom) {
    const className = String(vdom?.attrs?.className || '');
    if (!className.includes('TypingUsersContainer-active')) return;
    const users = vdom.children?.find(child => child && String(child.attrs?.className || '').includes('TypingUsers'));
    if (!users || !Array.isArray(users.children)) return;

    // O primeiro filho é o ícone; o texto vem depois e as reticências no fim.
    users.children = users.children.slice(1).concat(wave());
  });
}
flarum.reg.add('ramon-canela', 'forum/motion/typing', installTyping);